import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import Leadership from "./Leadership.svelte";

export default {
    component: Leadership,
    name: "Leadership",
    description: "Display team members with headshots, roles and LinkedIn profiles",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/users-group.svg",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/atoms-leadership--docs`,
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2Fb8efbdf1d7af419f97642d52e00adee1",
    inputs: [
        {
            friendlyName: "Title",
            name: "title",
            type: "text",
            required: true,
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('title') !== ''`,
        },
        {
            friendlyName: "Description",
            name: "description",
            type: "longText",
            required: true,
        },
        {
            friendlyName: "Background Colour",
            name: "backgroundColour",
            type: "color",
        },
        {
            friendlyName: "Text Colour",
            name: "txtColour",
            type: "color",
        },
        {
            friendlyName: "People",
            name: "people",
            type: "list",
            subFields: [
                {
                    friendlyName: "Name",
                    name: "name",
                    type: "text",
                    required: true,
                },
                {
                    friendlyName: "Role",
                    name: "role",
                    type: "text",
                    required: true,
                },
                {
                    friendlyName: "LinkedIn Profile",
                    name: "linkedin",
                    type: "url",
                    helperText:
                        "LinkedIn profile URL for this person (e.g., https://www.linkedin.com/in/username)",
                },
                // ImageInputsTemplate <-- see this template
                {
                    friendlyName: "Headshot",
                    name: "image",
                    type: "object",
                    helperText: "1:1 Aspect Ratio",
                    subFields: [
                        {
                            friendlyName: "Source",
                            name: "src",
                            type: "file",
                            allowedFileTypes: ["jpg", "webm", "gif", "png"],
                            defaultValue: "https://placehold.co/400",
                            required: true,
                        },
                        {
                            friendlyName: "Alt",
                            name: "alt",
                            type: "text",
                        },
                    ],
                },
                {
                    friendlyName: "Headshot 2",
                    name: "image2",
                    type: "object",
                    helperText: "1:1 Aspect Ratio",
                    subFields: [
                        {
                            friendlyName: "Source",
                            name: "src",
                            type: "file",
                            allowedFileTypes: ["jpg", "webm", "gif", "png"],
                            defaultValue: "https://placehold.co/400",
                            required: true,
                        },
                        {
                            friendlyName: "Alt",
                            name: "alt",
                            type: "text",
                        },
                    ],
                },
            ],
        },
    ],
};
